exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section-home .row-top .col.col-xl-3[data-v-13bb54f8]:first-child{padding-left:0;padding-right:8px}.section-home .row-top .col.col-xl-3[data-v-13bb54f8]:nth-child(2),.section-home .row-top .col.col-xl-3[data-v-13bb54f8]:nth-child(3){padding-left:8px;padding-right:8px}.section-home .row-top .col.col-xl-3[data-v-13bb54f8]:nth-child(4){padding-left:8px;padding-right:0}.section-home .row-bottom[data-v-13bb54f8]{height:461px}.section-home.active-menu .overlay[data-v-13bb54f8]{display:block}.section-home .overlay[data-v-13bb54f8]{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,81,137,.82);z-index:999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-13bb54f8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/home/home.scss
// module id = DdNR
// module chunks = 2